import {
	HubDataSource,
	HubItemCategoryModel,
	HubItemDataSource
} from "client/Api/Hub/hub";
import { KnowledgeItemPreviewItemModel } from "client/Api/Hub/KnowledgeItems/knowledgeItemViewer";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { ActiveFilter, HubViewChangeHandler } from "../common";
import { List } from "../KnowledgeItems/CategoryOverview/List/List";
import styles from "./Overview.module.less";
import { useOverviewSection } from "./useOverviewSection";
import { ViewAll } from "./ViewAll";
import { TimeZone } from "client/DateAndTime/timezones";

export type KnowledgeItemSectionProps = {
	items: readonly KnowledgeItemPreviewItemModel[];
	isMobile: boolean;
	onViewChange: HubViewChangeHandler;
	onActiveFilterChange: (activeFilter: ActiveFilter | null) => void;
	getCategory: (categoryId: number | null) => HubItemCategoryModel | undefined;
	onSelectCategory: (source: HubItemDataSource, categoryId: number | null) => void;
	timezone: TimeZone;
};

export const KnowledgeItemSection = (props: KnowledgeItemSectionProps): ReactElement => {
	const {
		items,
		isMobile,
		onViewChange,
		getCategory,
		onActiveFilterChange,
		onSelectCategory,
		timezone
	} = props;

	const {
		viewAllHandler,
		viewItemHandler,
		activeFilterChangeHandler
	} = useOverviewSection(
		HubDataSource.KnowledgeItem,
		onViewChange,
		onActiveFilterChange,
		onSelectCategory
	);

	return (
		<section>
			<header className={styles.sectionHeader}>
				<h3 className={styles.sectionTitle}>
					{localize("_LatestKnowledgeArticles")}
				</h3>

				{!isMobile && (
					<ViewAll
						itemSource={HubDataSource.KnowledgeItem}
						onClick={viewAllHandler}
						variant="anchor"
					/>
				)}
			</header>

			<List
				trackingId="knowledge-item-list"
				items={items}
				onNavigateToItem={viewItemHandler}
				getCategory={getCategory}
				onActiveFilterChange={activeFilterChangeHandler}
				onSelectedCategoryIdChange={(x) => onSelectCategory(HubDataSource.KnowledgeItem, x)}
				collapseMode={{
					kind: isMobile
						? "limited-items"
						: "one-row",
					isCollapsed: true,
					maxItemsCount: isMobile
						? MAX_MOBILE_ITEMS_TO_RENDER
						: Number.MAX_SAFE_INTEGER
				}}
				shouldAlwaysRenderMoreButton
				renderMoreButton={
					isMobile
						? (
							<ViewAll
								itemSource={HubDataSource.KnowledgeItem}
								onClick={viewAllHandler}
								variant="list-item"
							/>
						)
						: <></>
				}
				timezone={timezone}
			/>
		</section>
	);
};
KnowledgeItemSection.displayName = "KnowledgeItemSection";

const MAX_MOBILE_ITEMS_TO_RENDER = 3;
